<template>
    <div
        :aria-expanded="isOpen"
        :class="{'is-open': isOpen}"
        role="tab"
        class="app-collapse">
        <div
            tabindex="0"
            role="button"
            class="app-collapse__header"
            @click="handleToggle"
            @keyup.space.enter.stop="handleToggle">
            {{ title }}
            <i :class="{'rotate': isOpen}" class="collapse-item__arrow icon-dropdown"/>
        </div>
        <transition name="accordion"
                    @before-enter="beforeEnter" 
                    @enter="enter"
                    @before-leave="beforeLeave" 
                    @leave="leave">
            <div v-show="isOpen" class="app-collapse__body">
                <slot/>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'app-collapse-item',
    props: {
        title: String
    },
    data() {
        return {
            isOpen: false
        }
    },
    methods: {
        handleToggle() {
            this.isOpen = !this.isOpen
        },
        beforeEnter: function(el) {
            el.style.height = '0';
        },
        enter: function(el) {
            el.style.height = el.scrollHeight + 'px';
        },
        beforeLeave: function(el) {
            el.style.height = el.scrollHeight + 'px';
        },
        leave: function(el) {
            el.style.height = '0';
        }
    }
}
</script>

<style lang="stylus" scoped>
    .app-collapse
        border-top: 1px solid #ebeef5;
        margin-bottom: 20px
        &.is-open
            padding-bottom: 20px

    .app-collapse__header
        display: flex
        -webkit-box-align: center
        -ms-flex-align: center
        align-items: center
        height: 48px
        line-height: 48px
        background-color: #fff
        color: #303133
        cursor: pointer
        font-size: 13px
        font-weight: 500
        transition: border-bottom-color .3s
        outline: 0
    .app-collapse__body
        transition: .3s ease-out
        overflow: hidden
    .collapse-item__arrow
        margin-right: 10px
        margin-left: auto
        transition: .3s
        transform: rotate(-90deg)
        &.rotate
            transform: rotate(0deg)
            
</style>
